import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import data from "../ApiUrl/meta_api.js";
import "../../assets/css/iat.css";
import { MdArrowRight } from "react-icons/md";
import { FiChevronRight } from "react-icons/fi";

import pdfFile3 from "../../assets/pdf/Advanced Industrial Automation Expert.webp";
import pdfFile2 from "../../assets/pdf/Certified Industrial Automation professional.webp";
import pdfFile1 from "../../assets/pdf/Industrial_Automation_Essentials.webp";
import pdfFile from "../../assets/pdf/Industrial_Automation_Quick_Start.webp";
import pdfFile4 from "../../assets/pdf/Professional In Advanced Industrial Automation.webp";

import APP_logo from "../../assets/img/Logo/logo-6.jpg";
import mitsubishi from "../../assets/img/Logo/logo-1.jpg";
import siemens from "../../assets/img/Logo/logo-2.jpg";
import rockwell from "../../assets/img/Logo/logo-5.jpg";
import delta from "../../assets/img/Logo/logo-3.jpg";
import omron from "../../assets/img/Logo/logo-4.jpg";

//Icon
import expert_icon from "../../assets/icons/expert-instructer.png";
import hands_on_lab from "../../assets/icons/hands-on-lab.png";
import industry_certificate from "../../assets/icons/industry-certificate.png";
import flexiable_learn from "../../assets/icons/flexiable-learning.png";
import placement_icon from "../../assets/icons/palcement-icon.png";
import industry_icon from "../../assets/icons/industry-icon.png";
import clock_icon from '../../assets/icons/clock-icon.png'

/* ══════════════════════════════════════════════════════════════
   DATA
══════════════════════════════════════════════════════════════ */

const heroStats = [
  { num: "5000+", label: "Students Trained" },
  { num: "92%", label: "Placement Rate" },
  { num: "6", label: "Certification Courses" },
  { num: "4.8 ★", label: "Student Rating" },
];

const whyCards = [
  {
    icon: expert_icon,
    title: "Expert Instructors",
    desc: "Learn from certified automation engineers with 10+ years of hands-on industry experience in PLC, SCADA, robotics, and process control systems.",
  },
  {
    icon: hands_on_lab,
    title: "Hands-On Lab Training",
    desc: "Practice on genuine industrial hardware — Siemens, Allen-Bradley, Mitsubishi, Schneider — not just software simulators.",
  },
  {
    icon: industry_certificate,
    title: "Industry-Recognised Certification",
    desc: "Earn certifications valued by manufacturing, energy, and logistics companies across India and globally.",
  },
  {
    icon: flexiable_learn,
    title: "Flexible Learning Modes",
    desc: "Choose in-person classroom, live online, or hybrid training — structured to fit your schedule and learning pace.",
  },
  {
    icon: placement_icon,
    title: "Placement Assistance",
    desc: "Dedicated career support — resume building, mock interviews, and direct referrals to our verified hiring partner network.",
  },
  {
    icon: industry_icon,
    title: "Industry 4.0 Curriculum",
    desc: "Our syllabus is continuously updated to cover IIoT, Industry 4.0, and the latest automation technologies and standards.",
  },
];

const courseData = {
  beginner: [
    {
      id: "Industrial Automation Quick start",
      title: "Industrial Automation Quick Start",
      dur: "1 Month",
      level: "Beginner",
      img: "automationc-1.webp",
      desc: "A fast-track introduction covering core concepts of control systems, sensors, actuators, and PLC-based automation. Ideal for students and freshers exploring the field for the first time.",
      topics: ["Introduction to Automation", "Sensors & Actuators", "Basic PLC Concepts", "Safety in Automation"],
    },
    {
      id: "Industrial Automation Essentials",
      title: "Industrial Automation Essentials",
      dur: "2 Months",
      level: "Beginner",
      img: "prog_c-2.webp",
      desc: "Build a solid foundation with PLC programming basics, ladder logic, HMI fundamentals, and process control principles. Perfect for engineers stepping into the automation industry.",
      topics: ["Ladder Logic Programming", "HMI Basics", "Process Control Fundamentals", "Panel Wiring & Reading"],
    },
  ],
  intermediate: [
    {
      id: "Certified Industrial Automation professional",
      title: "Certified Industrial Automation Professional",
      dur: "3 Months",
      level: "Intermediate",
      img: "adv_plc_c4.webp",
      desc: "A comprehensive certification covering advanced PLC programming, structured text, communication protocols, and real-world project integration — for professional automation engineer roles.",
      topics: ["Advanced PLC Programming", "Structured Text & FBD", "Communication Protocols", "Live Project Integration"],
    },
    {
      id: "Advanced Industrial Automation Expert",
      title: "Advanced Industrial Automation Expert",
      dur: "6 Months",
      level: "Intermediate",
      img: "sca_da_data_acq_c5.webp",
      desc: "Master SCADA system design, data acquisition, industrial networking, and remote monitoring. Bridges the gap between field automation and enterprise-level control systems.",
      topics: ["SCADA System Design", "Data Acquisition (DAQ)", "Industrial Networking & Protocols", "Remote Monitoring & Control"],
    },
  ],
  advanced: [
    {
      id: "Professional in Advanced Industrial Automation",
      title: "Professional in Advanced Industrial Automation",
      dur: "9 Months",
      level: "Advanced",
      img: "c7.webp",
      desc: "The most comprehensive program — covering industrial robotics, IIoT integration, Industry 4.0, advanced motion control, and full-scale system commissioning for senior roles.",
      topics: ["Industrial Robotics & Motion Control", "IIoT & Industry 4.0 Integration", "System Commissioning", "Advanced Troubleshooting"],
    },
  ],
};

const journeySteps = [
  {
    icon: "fa-industry",
    label: "Assess Your Training Goals",
    desc: "Identify your current skill level and the automation domain — PLC, SCADA, robotics, or networking — that aligns with your career target.",
  },
  {
    icon: "fa-arrow-up-right-from-square",
    label: "Choose the Right Program",
    desc: "Select from beginner, intermediate, or advanced certification programs, each designed to build progressively on the previous level.",
  },
  {
    icon: "fa-chart-line",
    label: "Gain Hands-On Experience",
    desc: "Work on real automation equipment and live industry projects during training, building a tangible portfolio before you start applying.",
  },
  {
    icon: "fa-building-columns",
    label: "Get Certified & Get Hired",
    desc: "Complete your certification and access full placement support — resume crafting, mock interviews, and recruiter referrals — until you land the right role.",
  },
];

const testimonials = [
  {
    initials: "RK",
    bg: "#cc0000",
    name: "Rajan K.",
    course: "PLC & SCADA · B.E. Electrical",
    quote: "The practical sessions on real Siemens PLCs gave me the edge. I walked into my interview fully prepared and landed an Automation Engineer role within 6 weeks of completing the course.",
    result: "Automation Engineer — Manufacturing Firm",
  },
  {
    initials: "SM",
    bg: "#378ADD",
    name: "Swetha M.",
    course: "Certified Automation Professional · Career Switcher",
    quote: "I switched from a non-technical background. The structured curriculum and constant instructor support made the transition smooth. The mock interview sessions were a complete game-changer.",
    result: "PLC Technician — Process Industry",
  },
  {
    initials: "AV",
    bg: "#1D9E75",
    name: "Aravind V.",
    course: "Advanced Automation Expert · Fresher",
    quote: "The SCADA project I built during training was what every interviewer asked about. Having a real, working system in my portfolio made all the difference during the hiring process.",
    result: "SCADA Engineer — Energy Sector",
  },
];

const partnerLogos = [
  { name: "Mitsubishi", img: mitsubishi },
  { name: "ABB", img: APP_logo },
  { name: "Siemens", img: siemens },
  { name: "Rockwell", img: rockwell },
  { name: "Delta", img: delta },
  { name: "Omron", img: omron },
];

const faqItems = [
  {
    q: "What is industrial automation training and why is it important?",
    a: "Industrial automation training equips engineers and technicians with skills to design, program, operate, and maintain automated systems using PLCs, SCADA, HMI, robotics, and industrial networks. With manufacturing and process industries worldwide accelerating automation adoption, certified professionals are in consistently high demand.",
  },
  {
    q: "Who should enrol in Skimitar Hindusthan's automation courses?",
    a: "These programs are ideal for B.E./B.Tech graduates in Electrical, Electronics, Mechanical, or Instrumentation, diploma holders, ITI students, and working professionals seeking skill upgrades or a domain switch into the automation industry.",
  },
  {
    q: "What certifications will I receive upon completion?",
    a: "You receive an industry-recognised certification from Skimitar Hindusthan, aligned with real-world competencies tested by employers in automation, manufacturing, and energy sectors across India.",
  },
  {
    q: "Are courses available in online mode?",
    a: "Yes. We offer in-person classroom training at our Salem and Erode centres, live online sessions, and hybrid modes — so you can learn without disrupting current studies or employment.",
  },
  {
    q: "What career roles can I target after this training?",
    a: "Graduates typically secure roles such as PLC Engineer, SCADA Operator, Automation Technician, Control Systems Engineer, DCS Engineer, Maintenance Engineer, and Industrial IoT Developer across manufacturing, energy, automotive, and logistics sectors.",
  },
  {
    q: "Is placement support included?",
    a: "Yes. Every enrolled student receives dedicated placement support including professional resume building, mock technical and HR interview sessions, LinkedIn profile optimisation, and direct referrals to our verified hiring partner network.",
  },
];

/* ══════════════════════════════════════════════════════════════
   HOOKS
══════════════════════════════════════════════════════════════ */

function useScrollReveal(sectionRef, selector = ".scroll-reveal", delay = 85) {
  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;
    const cards = Array.from(section.querySelectorAll(selector));
    if (!cards.length) return;

    cards.forEach((card, i) => {
      card.style.opacity = "0";
      card.style.transform = i % 2 === 0 ? "translateX(-60px)" : "translateX(60px)";
      card.style.transition = "all 0.7s cubic-bezier(0.25,0.46,0.45,0.94)";
    });

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            Array.from(entry.target.querySelectorAll(selector)).forEach((card, idx) => {
              setTimeout(() => {
                card.style.opacity = "1";
                card.style.transform = "translateX(0)";
              }, idx * delay);
            });
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -50px 0px" },
    );
    observer.observe(section);
    return () => observer.disconnect();
  }, [delay, selector]);
}

function useFadeInUp(ref) {
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.opacity = "0";
    el.style.transform = "translateY(28px)";
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.style.transition =
            "opacity 0.7s cubic-bezier(0.25,0.46,0.45,0.94), transform 0.7s cubic-bezier(0.25,0.46,0.45,0.94)";
          el.style.opacity = "1";
          el.style.transform = "translateY(0)";
          observer.disconnect();
        }
      },
      { threshold: 0.12 },
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
}

/* ══════════════════════════════════════════════════════════════
   SHARED UI — matches Career page pattern exactly
══════════════════════════════════════════════════════════════ */

function SectionLabel({ text }) {
  return (
    <p className="iat-label fw-semibold text-uppercase mb-1">{text}</p>
  );
}

function SectionHeader({ label, title, sub }) {
  return (
    <div className="mb-5">
      <div className="d-flex align-items-center gap-3 mb-2">
        <div className="iat-line" />
        <span className="iat-label" style={{ whiteSpace: "nowrap" }}>
          {label}
        </span>
        <div className="iat-line" />
      </div>
      <h2 className="iat-sec-title fw-bold text-uppercase mt-2">{title}</h2>
      {sub && (
        <p className="mt-2" style={{ maxWidth: "720px", lineHeight: "1.75" }}>
          {sub}
        </p>
      )}
    </div>
  );
}

/* ══════════════════════════════════════════════════════════════
   1 — HERO
══════════════════════════════════════════════════════════════ */
function Hero() {
  return (
    <section className="iat-hero position-relative overflow-hidden">
      <div
        className="iat-hero-bg"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.62),rgba(0,0,0,0.72)),url(${require("../../assets/images/Services/IAT/industrialautomation.webp")})`,
        }}
      />
      <div className="container iat-container position-relative py-5" style={{ zIndex: 1 }}>
        <div className="d-flex justify-content-center mb-3">
          <div className="iat-hero-badge px-4 py-2 rounded-4">
            <span className="text-uppercase fw-semibold" style={{ letterSpacing: "3px", fontSize: "13px" }}>
              Industrial Automation Training
            </span>
          </div>
        </div>

        <h1
          className="iat-hero-title text-white text-center fw-bold mb-3 iat-fade"
          style={{ animationDelay: "0.1s" }}
        >
          Master Industrial Automation.
          <br />
          <em className="text-red" style={{ fontStyle: "normal" }}>
            Build a Career That Runs the Future.
          </em>
        </h1>

        <p
          className="text-center mx-auto mb-4 iat-fade text-white"
          style={{ maxWidth: "700px", animationDelay: "0.2s", lineHeight: "1.8" }}
        >
          <b>Skimitar Hindusthan's</b> PLC, SCADA, and Industrial Automation training programs equip
          you with real hands-on skills — on real equipment — to succeed in today's rapidly evolving
          manufacturing and process industries.
        </p>
      </div>
    </section>
  );
}

/* ══════════════════════════════════════════════════════════════
   2 — ABOUT
══════════════════════════════════════════════════════════════ */
function About() {
  const ref = useRef(null);
  useFadeInUp(ref);
  return (
    <section className="py-5 iat-sec-gap">
      <div className="container iat-container" ref={ref}>
        <div className="row g-5 align-items-center">
          <div className="col-lg-6">
            <img
              src={require("../../assets/images/Services/IAT/Pros And Cons of AI In Manufacturing.webp")}
              alt="Industrial Automation Training at Skimitar Hindusthan"
              className="iat-about-img shadow"
            />
          </div>
          <div className="col-lg-6">
            <SectionLabel text="Industrial Automation Training" />
            <h2 className="iat-sec-title fw-bold text-uppercase mt-2 mb-3">
              One Partner. Every Skill. Every Stage.
            </h2>
            <p style={{ lineHeight: "1.5" }}>
              <b>Skimitar Hindusthan's</b> Industrial Automation Training programs are designed to equip
              individuals with the technical expertise required to thrive in today's rapidly evolving
              automation industry. Our comprehensive curriculum covers Programmable Logic Controllers (PLC),
              Supervisory Control and Data Acquisition (SCADA), Human Machine Interfaces (HMI), industrial
              robotics, process control, and industrial networking.
            </p>
            <p style={{ lineHeight: "1.5" }}>
              Participants gain hands-on experience on real automation systems, enabling them to design,
              implement, troubleshoot, and maintain automated solutions across sectors including manufacturing,
              energy, automotive, and logistics. Our curriculum is continuously updated to reflect Industry 4.0
              standards, IIoT trends, and the latest best practices — ensuring every graduate is genuinely
              industry-ready from day one.
            </p>
            <p style={{ lineHeight: "1.5"}}>
              Whether you are a fresher beginning your automation career or a working professional upgrading
              your skills, Skimitar Hindusthan provides the structured learning, practical exposure, and
              dedicated placement support needed to accelerate your professional growth in the automation sector.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

/* ══════════════════════════════════════════════════════════════
   3 — WHY CHOOSE  (Career page ProcessSection pattern)
══════════════════════════════════════════════════════════════ */
function WhyChoose() {
  const sRef = useRef(null);
  useScrollReveal(sRef, ".scroll-reveal", 85);
  return (
    <section className="py-5 bg-iat-soft iat-sec-gap" ref={sRef}>
      <div className="container iat-container py-lg-4">
        <SectionHeader
          label="Why Choose Us"
          title="Why Choose Skimitar Hindusthan for Automation Training"
          sub="We combine industry-expert instruction, real equipment labs, and dedicated placement support to deliver a training experience that translates directly into employment."
        />
        <div className="row g-4">
          {whyCards.map((c) => (
            <div key={c.title} className="col-md-6 col-lg-4 scroll-reveal">
              {/* card border-0 shadow-sm rounded-0 — exact Career page pattern */}
              <div className="card h-100 border-0 shadow-sm rounded-0 bg-white iat-card-hover">
                <div className="card-body p-4 text-center">
                  <img src={c.icon} alt={c.title} className="mb-3" style={{ width: "44px", height: "44px", objectFit: "contain" }} />
                  <p className="fw-bold text-uppercase mb-2">{c.title}</p>
                  <p className="mb-0" style={{ lineHeight: "1.75", color: "#555" }}>{c.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ══════════════════════════════════════════════════════════════
   4 — TRAINING PROGRAMS
══════════════════════════════════════════════════════════════ */
function TrainingPrograms({ onEnquire }) {
  const [tab, setTab] = useState("beginner");
  const sRef = useRef(null);
  useScrollReveal(sRef, ".scroll-reveal", 90);

  const tabs = [
    { key: "beginner", label: "Beginner Courses" },
    { key: "intermediate", label: "Intermediate Courses" },
    { key: "advanced", label: "Advanced Courses" },
  ];

  return (
    <section className="py-5 iat-sec-gap" ref={sRef}>
      <div className="container iat-container py-lg-4">
        <SectionHeader
          label="Our Training Programs"
          title="PLC, SCADA & Automation Certification Courses"
          sub="Explore our range of structured certification programs — from beginner fundamentals to advanced professional qualifications — designed for every stage of your automation career."
        />

        {/* ── Tab buttons — Bootstrap btn-group, btn-outline-danger pattern ── */}
        <div className="row g-2 mb-5 justify-content-center">
          {tabs.map((t) => {
            const isActive = tab === t.key;
            return (
              <div key={t.key} className="col-12 col-sm-4">
                <button
                  className={`btn w-100 fw-bold iat-tab rounded-0 rounded-4 ${isActive ? "btn-danger text-white" : "btn-outline-danger"
                    }`}
                  style={{ padding: "10px 0" }}
                  onClick={() => setTab(t.key)}
                >
                  {t.label}
                </button>
              </div>
            );
          })}
        </div>

        {/* ── Cards ── */}
        <div className="row g-4">
          {courseData[tab].map((course) => (
            <div key={course.id} className="col-md-6 scroll-reveal">
              {/* card border-0 shadow-sm rounded-0 — exact Career page pattern */}
              <div className="card h-100 border-0 shadow-sm rounded-0 iat-card-hover">
                <img
                  src={require(`../../assets/images/Services/IAT/${course.img}`)}
                  alt={`${course.title} — Skimitar Hindusthan`}
                  className="iat-course-img"
                />
                <div className="card-body p-4 d-flex flex-column">

                  {/* Meta row */}
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <span className="iat-badge-pill">Industrial Automation</span>
                    <span className="fw-semibold text-red" style={{ fontSize: "13px" }}>
                      {course.level}
                    </span>
                  </div>

                  {/* Title */}
                  <h3 className="fw-bold text-red mb-2" style={{ fontSize: "17px" }}>
                    {course.title}
                  </h3>

                  {/* Desc */}
                  <p className="mb-3" style={{ lineHeight: "1.75" }}>
                    {course.desc}
                  </p>

                  {/* Topics */}
                  <p
                    className="fw-semibold text-uppercase mb-2"
                    style={{ fontSize: "12px", letterSpacing: "1px" }}
                  >
                    Key Topics
                  </p>
                  <div className="d-flex flex-wrap gap-2 mb-3">
                    {course.topics.map((t) => (
                      <span
                        key={t}
                        className="rounded-pill px-3 py-1"
                        style={{ background: "#f5f5f5", fontSize: "12px" }}
                      >
                        {t}
                      </span>
                    ))}
                  </div>

                  {/* Footer */}
                  {/* <div className="d-flex justify-content-between align-items-center mt-auto pt-3 border-top">
                    <span style={{ color: "#666", fontSize: "13px" }}>
                     
                      <img src={clock_icon} style={{width:'25px'}}/>
                      Duration — {course.dur}
                    </span>
                    <button
                      className="btn btn-sm btn-danger fw-bold text-uppercase rounded-0"
                      style={{ padding: "6px 18px", fontSize: "12px" }}
                      onClick={() => onEnquire(course.id)}
                    >
                      Enquire Now
                    </button>
                  </div> */}

                  <div
                    className="d-flex justify-content-between align-items-center mt-auto pt-3 border-top"
                    style={{ gap: '16px' }}
                  >
                    <div className="d-flex align-items-center" style={{ color: "#666", fontSize: "13px" }}>
                      <img src={clock_icon} style={{ width: '25px' }} alt="clock" className="me-2" />
                      Duration — {course.dur}
                    </div>

                    <button
                      className="btn btn-sm btn-danger fw-bold text-uppercase rounded-3 flex-shrink-0"
                      style={{ padding: "6px 18px", fontSize: "12px" }}
                      onClick={() => onEnquire(course.id)}
                    >
                      Enquire Now
                    </button>
                  </div>

                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}

/* ══════════════════════════════════════════════════════════════
   5 — AUTOMATION JOURNEY
══════════════════════════════════════════════════════════════ */
function AutomationJourney() {
  const sRef = useRef(null);
  useScrollReveal(sRef, ".scroll-reveal", 90);
  return (
    <section className="py-5 bg-iat-soft iat-sec-gap" ref={sRef}>
      <div className="container iat-container py-lg-4">
        <div className="row g-5 align-items-center">
          <div className="col-lg-6 order-2 order-lg-1">
            <SectionHeader
              label="Your Learning Path"
              title="How to Begin Your Industrial Automation Career"
            />
            <div className="d-flex flex-column gap-4">
              {journeySteps.map((step, i) => (
                <div key={step.label} className="d-flex gap-3 scroll-reveal">
                  <div className="iat-journey-icon flex-shrink-0">
                    <FiChevronRight size={20} />
                  </div>
                  <div>
                    <p className="fw-bold mb-1">
                      <span className="text-red me-1">0{i + 1}.</span>
                      {step.label}
                    </p>
                    <p className="mb-0" style={{ lineHeight: "1.75", color: "#555" }}>
                      {step.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="col-lg-6 order-1 order-lg-2">
            <img
              src={require("../../assets/images/Services/IAT/how to begin 2.webp")}
              alt="How to begin your automation career journey"
              className="iat-about-img shadow"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

/* ══════════════════════════════════════════════════════════════
   6 — PARTNER BRANDS
══════════════════════════════════════════════════════════════ */
function PartnerBrands() {
  const ref = useRef(null);
  useFadeInUp(ref);
  return (
    <section className="py-5 iat-sec-gap">
      <div className="container iat-container py-lg-4" ref={ref}>
        <SectionHeader
          label="Training Equipment"
          title="Brands & Equipment We Train You On"
          sub="Our labs are equipped with genuine hardware from the world's leading automation manufacturers — so your training mirrors actual industrial environments."
        />
        <div className="row g-4 justify-content-center align-items-center">
          {partnerLogos.map((p) => (
            <div key={p.name} className="col-6 col-sm-4 col-md-2 text-center">
              <img
                src={p.img}
                alt={`${p.name} PLC and automation training — Skimitar Hindusthan`}
                className="iat-logo-img"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ══════════════════════════════════════════════════════════════
   7 — TESTIMONIALS  (Career page SuccessStories pattern)
══════════════════════════════════════════════════════════════ */
function Testimonials() {
  const sRef = useRef(null);
  useScrollReveal(sRef, ".scroll-reveal", 100);
  return (
    <section className="py-5 bg-iat-soft iat-sec-gap" ref={sRef}>
      <div className="container iat-container py-lg-4">
        <SectionHeader
          label="Student Success Stories"
          title="Real Students. Real Skills. Real Careers."
          sub="Here is what Skimitar Hindusthan graduates say about their training experience and career outcomes."
        />
        <div className="row g-4">
          {testimonials.map((t) => (
            <div key={t.name} className="col-md-4 scroll-reveal">
              {/* card border-0 shadow-sm rounded-0 overflow-hidden — Career page pattern */}
              <div className="card h-100 border-0 shadow-sm rounded-0 overflow-hidden iat-card-hover">
                {/* Dark header — same as cr-story-top */}
                <div className="p-4" style={{ background: "#1a1a1a" }}>
                  <div
                    className="d-flex align-items-center justify-content-center rounded-circle mb-3 fw-bold"
                    style={{ background: t.bg, color: "#fff", width: "48px", height: "48px", flexShrink: 0 }}
                  >
                    {t.initials}
                  </div>
                  <p className="fw-bold text-white mb-1">{t.name}</p>
                  <p className="mb-0" style={{ color: "#aaa" }}>{t.course}</p>
                </div>
                <div className="card-body p-4 bg-white">
                  <p className="fst-italic mb-3" style={{ lineHeight: "1.8", color: "#444" }}>
                    "{t.quote}"
                  </p>
                  <div
                    className="d-flex align-items-center gap-2 rounded-2 px-3 py-2"
                    style={{ background: "#E1F5EE" }}
                  >
                    <span className="iat-testi-dot" />
                    <span className="fw-semibold" style={{ color: "#085041" }}>{t.result}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ══════════════════════════════════════════════════════════════
   8 — FAQ
══════════════════════════════════════════════════════════════ */
function FAQ() {
  const ref = useRef(null);
  useFadeInUp(ref);
  return (
    <section className="py-5 iat-sec-gap">
      <div className="container iat-container py-lg-4" ref={ref}>
        <SectionHeader
          label="FAQ"
          title="Frequently Asked Questions"
          sub="Everything you need to know about our industrial automation training programs, certifications, and placement support."
        />
        <div className="accordion iat-accordion" id="iatFaq">
          {faqItems.map((item, i) => (
            <div className="accordion-item border-0 shadow-sm mb-3 rounded-0" key={i}>
              <h2 className="accordion-header">
                <button
                  className={`accordion-button fw-semibold ${i !== 0 ? "collapsed" : ""}`}
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#faqItem${i}`}
                >
                  {item.q}
                </button>
              </h2>
              <div
                id={`faqItem${i}`}
                className={`accordion-collapse collapse ${i === 0 ? "show" : ""}`}
                data-bs-parent="#iatFaq"
              >
                <div className="accordion-body" style={{ lineHeight: "1.8", color: "#555" }}>
                  {item.a}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ══════════════════════════════════════════════════════════════
   9 — CTA  (Career page CTA pattern)
══════════════════════════════════════════════════════════════ */
function CTASection() {
  return (
    <section className="iat-sec-gap">
      <div className="iat-cta p-4 p-lg-5">
        <div className="d-flex align-items-center justify-content-center gap-3 mb-3">
          <div className="iat-cta-eyebrow" />
          <span
            className="text-uppercase fw-semibold text-white text-opacity-75"
            style={{ letterSpacing: "2px", whiteSpace: "nowrap", fontSize: "13px" }}
          >
            Start Your Automation Career
          </span>
          <div className="iat-cta-eyebrow" />
        </div>
        <div className="row g-4 align-items-center">
          <div className="col-lg-7 text-center text-lg-start">
            <h2 className="fw-bolder text-white text-uppercase mb-3 iat-sec-title">
              Your Automation Career Starts at <b>Skimitar Hindusthan</b>
            </h2>
            <p className="text-white text-opacity-75 mb-0" style={{ lineHeight: "1.75" }}>
              Join thousands of students who chose structured automation training, built real hands-on
              skills, and launched successful careers — with <b>Skimitar Hindusthan's</b> practical,
              industry-aligned programs and dedicated placement support at every step.
            </p>
          </div>
          <div className="col-lg-5">
            <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center justify-content-lg-end">
              <button className="btn iat-btn-white px-4 py-3 fw-bold text-uppercase">
                Explore All Courses →
              </button>
              <button className="btn iat-btn-ghost px-4 py-3 fw-bold text-uppercase">
                📞 (+91) 8428010909
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

/* ══════════════════════════════════════════════════════════════
   ENQUIRY MODAL — unchanged logic
══════════════════════════════════════════════════════════════ */
function EnquiryModal({ courseId, onClose, pdfMap }) {
  const [form, setForm] = useState({
    student_name: "",
    email: "",
    mobile_no: "",
    location: "",
    Prefered_course: courseId || "",
    Source_type: "Website",
    Enquiry_date: new Date().toISOString().split("T")[0],
    followups_status: "New",
  });
  const [errors, setErrors] = useState({});
  const [showOther, setShowOther] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showDownload, setShowDl] = useState(false);
  const [dlData, setDlData] = useState(null);

  const formatTime = () =>
    new Date().toLocaleTimeString("en-GB", { hour12: false });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value, Prefered_course: courseId || prev.Prefered_course }));
    if (name === "location") setShowOther(value === "Others");
  };

  const validate = () => {
    const errs = {};
    if (!form.student_name.trim()) errs.student_name = "Name is required.";
    else if (!/^[a-zA-Z\s]+$/.test(form.student_name)) errs.student_name = "Name must contain only letters.";
    if (!form.email.trim()) errs.email = "Email is required.";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) errs.email = "Enter a valid email.";
    if (!form.mobile_no.trim()) errs.mobile_no = "Mobile is required.";
    else if (!/^\d{10}$/.test(form.mobile_no)) errs.mobile_no = "Must be 10 digits.";
    if (!form.location.trim()) errs.location = "Location is required.";
    return errs;
  };

  const handleSubmit = async () => {
    const errs = validate();
    if (Object.keys(errs).length) { setErrors(errs); return; }
    setErrors({});
    setIsLoading(true);
    try {
      const response = await axios.post(
        "",
        { ...form, fetched_course: courseId, Enquiry_time: formatTime() },
        { headers: { "Content-Type": "application/json" } },
      );
      if (response.status === 200) {
        const file = pdfMap[courseId];
        if (file) {
          setDlData({ fileUrl: file, fileName: courseId.replace(/\s+/g, "_").toLowerCase() });
          setShowDl(true);
        }
        toast.success("Enquiry submitted successfully!", { position: "top-center", autoClose: 2000 });
      }
    } catch {
      toast.error("Submission failed. Please try again.", { position: "top-right" });
    } finally {
      setIsLoading(false);
    }
  };

  const handleDownload = () => {
    if (!dlData) return;
    const link = document.createElement("a");
    link.href = dlData.fileUrl;
    link.download = dlData.fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setShowDl(false);
    onClose();
  };

  if (showDownload) {
    return (
      <div className="iat-modal-overlay" onClick={onClose}>
        <div className="iat-modal-box" onClick={(e) => e.stopPropagation()}>
          <button className="iat-modal-close" onClick={onClose}>×</button>
          <h5 className="fw-bold mb-2">Download Your Course Brochure</h5>
          <p style={{ color: "#555", lineHeight: "1.7" }}>
            Thank you for your enquiry! Click below to download the brochure for{" "}
            <strong>{courseId}</strong>.
          </p>
          <button className="btn fw-bold w-100 py-2 mt-2 iat-submit-btn" onClick={handleDownload}>
            Download Brochure
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="iat-modal-overlay" onClick={onClose}>
      <div className="iat-modal-box" onClick={(e) => e.stopPropagation()}>
        <button className="iat-modal-close" onClick={onClose}>×</button>
        <h5 className="fw-bold mb-1">Enquire About This Course</h5>
        <p className="text-red fw-semibold mb-4" style={{ fontSize: "14px" }}>{courseId}</p>

        <div className="iat-float">
          <input type="text" name="student_name" placeholder=" " value={form.student_name} onChange={handleChange} />
          <label>Your Name *</label>
          {errors.student_name && <div className="text-danger mt-1" style={{ fontSize: "13px" }}>{errors.student_name}</div>}
        </div>

        <div className="iat-float">
          <input type="email" name="email" placeholder=" " value={form.email} onChange={handleChange} />
          <label>Email Address *</label>
          {errors.email && <div className="text-danger mt-1" style={{ fontSize: "13px" }}>{errors.email}</div>}
        </div>

        <div className="iat-float">
          <input type="tel" name="mobile_no" placeholder=" " value={form.mobile_no} onChange={handleChange} />
          <label>Mobile Number *</label>
          {errors.mobile_no && <div className="text-danger mt-1" style={{ fontSize: "13px" }}>{errors.mobile_no}</div>}
        </div>

        <div className="iat-float">
          <select name="location" value={form.location} onChange={handleChange}>
            <option value="">Select Location</option>
            <option value="Salem">Salem</option>
            <option value="Erode">Erode</option>
            <option value="Others">Others</option>
          </select>
          {errors.location && <div className="text-danger mt-1" style={{ fontSize: "13px" }}>{errors.location}</div>}
        </div>

        {showOther && (
          <div className="mb-3">
            <input
              type="text"
              name="other_location"
              className="form-control iat-input"
              placeholder="Enter your city / location"
              value={form.other_location || ""}
              onChange={handleChange}
            />
          </div>
        )}

        <div className="mb-4">
          <input
            type="text"
            className="form-control iat-input"
            value={courseId || ""}
            disabled
            style={{ background: "#f9f9f9", color: "#666" }}
          />
          <small className="text-muted">Preferred Course</small>
        </div>

        <button
          className="btn iat-submit-btn w-100 fw-bold text-uppercase py-3"
          onClick={handleSubmit}
          disabled={isLoading}
        >
          {isLoading ? "Submitting…" : "Submit Enquiry →"}
        </button>
        <p className="text-center mt-3 mb-0" style={{ color: "#888" }}>
          Free enquiry · No commitment · Response within 24 hours
        </p>
      </div>
    </div>
  );
}

/* ══════════════════════════════════════════════════════════════
   MAIN EXPORT
══════════════════════════════════════════════════════════════ */
function IndustrialAutomation() {
  const [meta, setMeta] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [modalCourse, setModalCourse] = useState(null);

  useEffect(() => {
    const pageMeta = data[0]?.industrial_automation_page;
    if (pageMeta) setMeta(pageMeta);
  }, []);

  useEffect(() => {
    const t = setTimeout(() => setIsLoading(false), 1500);
    return () => clearTimeout(t);
  }, []);

  const pdfMap = {
    "Industrial Automation Quick start": pdfFile,
    "Industrial Automation Essentials": pdfFile1,
    "Certified Industrial Automation professional": pdfFile2,
    "Advanced Industrial Automation Expert": pdfFile3,
    "Professional in Advanced Industrial Automation": pdfFile4,
  };

  return (
    <>
      <Helmet>
        <title>
          {meta
            ? meta.title
            : "Industrial Automation Training — PLC, SCADA, Robotics Courses | Skimitar Hindusthan"}
        </title>
        <meta
          name="description"
          content="Enrol in Skimitar Hindusthan's industry-recognised Industrial Automation Training programs covering PLC, SCADA, HMI, Robotics, and IIoT. Hands-on lab training with placement support in Salem and Erode, Tamil Nadu."
        />
        <link rel="canonical" href="https://skimitaracademy.com/industrialautomation" />
      </Helmet>

      {isLoading && (
        <div className="iat-loader">
          <img src={require("../../assets/images/SH Logo.webp")} alt="Loading Skimitar Hindusthan" />
        </div>
      )}

      <div className="iat-page overflow-x-hidden">
        <Hero />
        <About />
        <WhyChoose />
        <TrainingPrograms onEnquire={(id) => setModalCourse(id)} />
        <AutomationJourney />
        <PartnerBrands />
        {/* <Testimonials /> */}
        <FAQ />
        <CTASection />

        {modalCourse && (
          <EnquiryModal
            courseId={modalCourse}
            onClose={() => setModalCourse(null)}
            pdfMap={pdfMap}
          />
        )}

        <ToastContainer />
      </div>
    </>
  );
}

export default IndustrialAutomation;